import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../translations";

const LanguageContext = createContext();

export const languages = [
  { code: "en", name: "English", flag: "EN" },
  { code: "hi", name: "हिन्दी", flag: "HI" },
  { code: "ar", name: "العربية", flag: "AR", rtl: true },
  { code: "fr", name: "Français", flag: "FR" },
  { code: "id", name: "Bahasa", flag: "ID" },
  { code: "sw", name: "Kiswahili", flag: "SW" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    const isRtl = languages.find((l) => l.code === lang)?.rtl;
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
  }, [lang]);

  const t = (key) => {
    return translations[lang]?.[key] || translations["en"]?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
